import axios from "axios";
import { API_BASE_URL, REQUEST_TIMEOUT } from "./constants";
import { createLog, dataHelper } from "../../helpers";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: REQUEST_TIMEOUT,
  headers: { "Content-Type": "application/json" }
});

apiClient.interceptors.request.use((config) => {
  const token = dataHelper.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const parseResponse = (response) => {
  if (!response) return null;
  if (response.data && Object.prototype.hasOwnProperty.call(response.data, "data")) {
    return response.data.data;
  }
  return response.data;
};

export default async function request(options) {
  const method = (options?.method || "GET").toUpperCase();
  const url = (options?.url || "").trim();

  const config = {
    method,
    url,
    headers: options?.headers || {}
  };

  if (options?.isMultipart) {
    config.headers["Content-Type"] = "multipart/form-data";
  }

  if (method === "GET") {
    config.params = options?.params || options?.body || {};
  } else if (options?.formData) {
    config.data = options.formData;
  } else {
    config.data = options?.body || {};
  }

  try {
    const response = await apiClient.request(config);
    return parseResponse(response);
  } catch (error) {
    createLog(`request-failed:${url}`, error?.message || error);

    const status = error?.response?.status;
    if (status === 401) {
      dataHelper.clearSession();
    }

    throw error;
  }
}
